module.exports = __webpack_public_path__ + "img/illustration-step-1-03.723606fc.svg";